import { ICardCollection } from '../interfaces/card.interfaces';

export class Cards {
  comreg: ICardCollection = {};
  accounts: ICardCollection = {};
  marketData: ICardCollection = {};
  providerData: ICardCollection = {};
}
